module.exports = __webpack_public_path__ + "static/media/OgKvT1024267_sm3.0e848ba0.png";